const TaskClose = (taskOriginal, id, thiss, gantt) => {
  // console.log("aaa", taskOriginal);
  if (!taskOriginal[0].read) {
    if (
      taskOriginal[0].parent != 0 &&
      taskOriginal[0].owner_id == thiss.currentUser.EmployeeId
    ) {
      thiss.$http
        .post("/api/CMI/Task/UpdateTaskStatus", {
          ResponsableID: thiss.currentUser.EmployeeId,
          CombinedId: id
        })
        .then(() => {
          gantt.message({
            text: "Tarea vista"
          });
          thiss.GetGanttObjectives();
          thiss.loadObjetiveNotification(thiss);
        })
        .catch((error) => console.error(error));
    } else if (taskOriginal[0].owner_id == thiss.currentUser.EmployeeId) {
      thiss.$http
        .post("/api/CMI/Objetives/UpdateObjetiveStatus", {
          ResponsableID: thiss.currentUser.EmployeeId,
          CombinedId: id
        })
        .then(() => {
          gantt.message({
            text: "Objetivo vista"
          });
          thiss.GetGanttObjectives();
          thiss.loadObjetiveNotification(thiss);
        })
        .catch((error) => console.error(error));
    }
  }
};

export default TaskClose;
